import { policyRuleStates } from './constants'

export const getStateParam = selectedState => (selectedState === policyRuleStates.all ? undefined : selectedState)
